import {
  faBuilding,
  faFlag,
  faSort,
  faToolbox,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.status_id",
        label: "Situação",
        placeholder: "Selecione a situação",
        type: "select",
        isClearable: true,
        icon: faFlag,
      }),
      createField({
        id: "filter.organization_id",
        label: "Organização",
        placeholder: "Selecione a organização",
        type: "select",
        isClearable: true,
        icon: faBuilding,
      }),
      createField({
        id: "filter.supplier_id",
        label: "Fornecedor",
        type: "select",
        placeholder: "Selecione o fornecedor",
        isClearable: true,
        icon: faTruck,
      }),
      createField({
        id: "filter.type_id",
        label: "Tipo do equipamento",
        placeholder: "Selecione o tipo do equipamento",
        type: "select",
        isClearable: true,
        icon: faToolbox,
      }),
      createField({
        id: "filter.order_by",
        label: "Ordernação",
        placeholder: "Selecione a ordem de classificação",
        type: "select",
        fullWidth: true,
        isClearable: true,
        icon: faSort,
      }),
    ],
  },
];
